import { Component, inject } from '@angular/core';
import { I18nService } from '../../core/services/i18n.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  template: `
    <div class="page-title">
      <h2>{{ i18n.t('dashboard.title') }}</h2>
      <p>{{ i18n.t('dashboard.subtitle') }}</p>
    </div>

    <div class="cards">
      <div class="card">
        <h3>{{ i18n.t('dashboard.folders') }}</h3>
        <p>{{ i18n.t('dashboard.ready') }}</p>
      </div>
      <div class="card">
        <h3>{{ i18n.t('dashboard.documents') }}</h3>
        <p>{{ i18n.t('dashboard.ready') }}</p>
      </div>
      <div class="card">
        <h3>{{ i18n.t('dashboard.verification') }}</h3>
        <p>{{ i18n.t('dashboard.ready') }}</p>
      </div>
    </div>
  `,
  styles: [`
    .page-title { margin-bottom:24px; }
    .cards { display:grid; grid-template-columns:repeat(3, 1fr); gap:16px; }
    .card { background:#fff; padding:20px; border-radius:16px; border:1px solid #e5e7eb; }
  `]
})
export class DashboardComponent {
  readonly i18n = inject(I18nService);
}
